// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YwIM","colBig":"styles_colBig__3Sw2v","colSmall":"styles_colSmall__3t_m8","shopifyNameWrapper":"styles_shopifyNameWrapper__5oXYI"};